//
// Generated class ProductClassification
//

/// <reference path="ProductClassification_ManagedObject.ts" />

class ProductClassification extends ProductClassification_ManagedObject
{

}
